'use strict';
const Plyr = require('plyr');

/**
 * This will initialize all plyr players.
 */
function initializePlayers() {
    var players = document.querySelectorAll('.js-player');
    var instances = [];

    for (var i = 0; i < players.length; i++) {
        instances.push(new Plyr(players[i]));
    }
}

module.exports = {
    init: $(document).ready(function () {
        initializePlayers();
    })
};
